export default __webpack_public_path__ + "static/media/left-arrow.b8112675.svg";